<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Listado de Planillas EI025</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Código" dense v-model="filtrocodigo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Cliente" dense v-model="filtrocliente">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Obra" dense v-model="filtroobra">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Responsable" dense v-model="filtroelaboro">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por N° de OT" dense v-model="filtronumot">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Estado" dense v-model="filtroestado">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListados()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="20000" :footer-props="{
                    itemsPerPageText: 'items por página',
                }">
                <!-- <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editarCotizacion(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small @click="verCotizacion(item)">
                        mdi-eye
                    </v-icon>
                </template> -->
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="ver(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="editar(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="orange" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="generar(item)">
                                mdi-content-copy
                            </v-icon>
                        </template>
                        <span>generar a partir de</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <VerEI025BT :visible="showVerBT" :codigo="editedItem.codigo" @close="showVerBT = false">
            </VerEI025BT>
            <VerEI025MT :visible="showVerMT" :codigo="editedItem.codigo" @close="showVerMT = false">
            </VerEI025MT>
            <EditarEI025BT :visible="showEditarBT" :codigo="editedItem.codigo" @close="showEditarBT = false">
            </EditarEI025BT>
            <GenerarEI025BT :visible="showGenerarBT" :codigoprop="editedItem.codigo" @close="showGenerarBT = false">
            </GenerarEI025BT>
            <EditarEI025MT :visible="showEditarMT" :codigo="editedItem.codigo" @close="showEditarMT = false">
            </EditarEI025MT>
            <GenerarEI025MT :visible="showGenerarMT" :codigoprop="editedItem.codigo" @close="showGenerarMT = false">
            </GenerarEI025MT>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth";
import VerEI025BT from "../EI025/InformeBT.vue";
import VerEI025MT from "../EI025/InformeMT.vue";
import EditarEI025BT from "../EI025/EditarBT.vue";
import GenerarEI025BT from "../EI025/GenerarBT.vue";
import EditarEI025MT from "../EI025/EditarMT.vue";
import GenerarEI025MT from "../EI025/GenerarMT.vue";
export default {
    components: { VerEI025BT, VerEI025MT, EditarEI025BT, GenerarEI025BT, EditarEI025MT, GenerarEI025MT },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            codgral: "",
            fact: "",
            cliente: "",
            obra: "",
            fecha: "",
            respcom: "",
            resptec: ""
        },
        editedIndex: -1,
        filtroobra: "",
        filtroelaboro: "",
        filtrocliente: "",
        filtrocodigo: "",
        filtronumot: "",
        filtroestado: "",
        listado: [],
        showVerBT: false,
        showVerMT: false,
        showEditarBT: false,
        showGenerarBT: false,
        showEditarMT: false,
        showGenerarMT: false,
        headers: [
            {
                text: "Código",
                align: "start",
                sortable: false,
                value: "codigo",
            },
            { text: "Tipo", value: "tipoplanilla", sortable: false },
            { text: "Cliente", value: "cliente", sortable: false },
            { text: "Obra", value: "obra", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Elaboró", value: "elaboro", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                //   this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            console.log("LISTADO")
            const codigo = this.filtrocodigo;
            const cliente = this.filtrocliente;
            const obra = this.filtroobra;
            const numot = this.filtronumot;
            const estado = this.filtroestado;
            const elaboro = this.elaboro;

            let self = this;

            axios
                .get("/Ingenieria/EI025Listado?", {
                    params: {
                        cliente: cliente,
                        obra: obra,
                        numot: numot,
                        codigo: codigo,
                        estado: estado,
                        elaboro: elaboro
                    },
                })
                .then((response) => {
                    self.listado = response.data;

                    //self.listadoP = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
        ver(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            if (item.tipoplanilla == "Baja Tensión") { this.showVerBT = true; }
            else { this.showVerMT = true; }
        },
        editar(item) {
            console.log("tipo pla ", item.tipoplanilla)
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            if (item.tipoplanilla == "Baja Tensión") { this.showEditarBT = true; }
            else { this.showEditarMT = true; }
        },
        generar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            if (item.tipoplanilla == "Baja Tensión") { this.showGenerarBT = true; }
            else { this.showGenerarMT = true; }
        },
        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>